<script>
import CloseButton from '@/components/Modals/CloseButton.vue';

export default {
    name: 'ValidationErrorsModal',
    components: { CloseButton },
    methods: {
        closeClicked() {
            this.$emit('close');
        },
        outlineClicked() {
            this.$emit('outline');
        },
    },


};
</script>

<template>
    <modal @modal-close="closeClicked">
        <div class="modal-wrapper">
            <CloseButton @click="closeClicked" />

            <div class="modal-content">
                <p>
                    {{ $t('You can’t submit this inspection, because some required check items have not been answered. In the checklist and outline, required check items are highlighted with a star.') }}
                </p>
            </div>

            <div class="modal-actions-outer-wrapper">
                <div class="modal-actions-inner-wrapper">
                    <button
                        type="button"
                        class="modal-actions-primary"
                        @click.prevent="outlineClicked"
                        >
                        {{ $t('See outline') }}
                    </button>
                </div>
            </div>

        </div>

    </modal>
</template>
